import { render, staticRenderFns } from "./purchaseOrder-add-or-update.vue?vue&type=template&id=2c888852&scoped=true"
import script from "./purchaseOrder-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchaseOrder-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./purchaseOrder-add-or-update.vue?vue&type=style&index=0&id=2c888852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c888852",
  null
  
)

export default component.exports